import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Loading from '@dynapp/wc-api-loading';
import DyncPopovers from 'dync-popovers';


Vue.config.productionTip = false;
Vue.use(Loading, {store});
Vue.use(DyncPopovers, {vuetify});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
